import "../css/App.css";
import "react-lazy-load-image-component/src/effects/blur.css";

// Render existing projects
// Show dates of existing projects
// Save a new event linked to a project - shape:
//  {
//                 location: "Monty", STRING INPUT
//                 city: "Antwerpen - BE", SEARCHFIELD
//                 dates: ["29-10-2026", "30-10-2026"], DATEPICKER
//                 url: "https://monty.be/programma/het-jaar-van-het-magisch-denken/", OPTIONAL?
//             },
// Use SUPABASE

function Adminpage() {
    return (
        <section
            className="hero  main-section"
            id="hero"
        >
            <div className="hero-description">
                <h1 className="hero-heading">Scarlet Tummers</h1>
            </div>
        </section>
    );
}

export default Adminpage;
